import authModule from './auth.module';
import { VuexModule,getModule, Module, Mutation, Action } from 'vuex-module-decorators';
import AuthService from '@/services/auth.service';
import store from './index'
import { format } from 'date-fns'
import device from '@/model/device';
import screendevicesrequest from '@/model/requests/screendevicesrequest';
import tagsModele from './tags.modele';
import screensModule from './screens.module';

@Module({ name:"Session", dynamic:true, store})
class Session extends VuexModule {

  public devices:device[]=[]

  @Mutation
public addDeviceMutation(device:device){
        device.starttimestring = format(device.starttime, "yyyy-MM-dd HH:mm")
        this.devices.push(device);
        this.devices = this.devices.sort((a, b) => (a.devicenumber < b.devicenumber ? -1 : 1))
  }

  @Mutation
  public clearAllDevicesMutation(){
    if (this.devices==null) return;
    this.devices.splice(0);
  }
  @Action({ rawError: true })
  public getScreenDevicesAction():Promise<device[]>{
    console.log("getScreenDevicesAction")
    return new Promise ((resolve)=>{ 
  
      AuthService.getscreendevices({token:authModule.currentUser.accessToken,
                            devices:[]},(data:string)=>{
        const response:screendevicesrequest = JSON.parse(data);
          const devices:device[] =  response.devices; 
         
          console.log(devices);
          resolve(devices)   
      },(data:string)=>{
        tagsModele.resetAllTagsAction();
        screensModule.clearScreens();
        console.log(data);
      });
    })
  } 
@Action
public getAllDevicesAction(){
  
    this.clearAllDevicesMutation();
    if (!authModule.currentUser) return;
    AuthService.getalldevices(authModule.currentUser.accessToken,(data:string)=>{
       console.log('data=',data)
        const device:device = JSON.parse(data);   
    //    console.log('device='+device);   
        this.addDeviceMutation(device);       
    },(data:string)=>{
      console.log('data=',data);
      this.clearAllDevicesMutation();
    });
} 

  get getAllDevices():device[]{
    return this.devices;
  }
}

export default getModule(Session);